import { backgroundOrange, darkOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const PickerList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
`

export const PickerRow = styled.button<{ $selected?: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 1rem 1.125rem;
    border-radius: 8px;
    background: ${({ $selected }) => ($selected ? backgroundOrange : 'white')};
    border: 1px solid ${({ $selected }) => ($selected ? orange : '#e5e7eb')};
    cursor: pointer;
    text-align: left;
    transition: all 0.15s;
    width: 100%;

    &:hover {
        border-color: ${orange};
        background: #fef9f6;
    }
`

export const Checkbox = styled.span<{ $checked: boolean }>`
    width: 22px;
    height: 22px;
    border-radius: 6px;
    border: 2px solid ${({ $checked }) => ($checked ? darkOrange : '#cbd5e1')};
    background: ${({ $checked }) => ($checked ? darkOrange : 'white')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: white;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
`

export const PickerAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const PickerName = styled.span`
    font-size: 0.9375rem;
    font-weight: 500;
    color: #262626;
    flex: 1;
`

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
`

export const Button = styled.button<{ $variant: 'primary' | 'ghost' }>`
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.15s ease;
    border: 1px solid transparent;

    background: ${({ $variant }) => ($variant === 'primary' ? darkOrange : 'transparent')};
    color: ${({ $variant }) => ($variant === 'primary' ? 'white' : darkOrange)};
    border-color: ${({ $variant }) => ($variant === 'primary' ? darkOrange : 'transparent')};

    &:hover {
        opacity: 0.9;
    }
`
